import type { Directive } from 'vue'
import { checkWebpSupport } from '~/utils/common'

const vWebp: Directive = {
  mounted(el) {
    let originalSrc = el.getAttribute('src') || el.getAttribute('data-src')
    if (!checkWebpSupport || !originalSrc) return
    if (originalSrc?.includes('undefined')) {
      originalSrc = ''
    }
    originalSrc = formatCover(originalSrc)
    if (isAddSuffix(originalSrc)) {
      originalSrc = originalSrc?.split('?')[0]
      if (el.className.includes('banner-img') || el.className.includes('not-watermark')) {
        if (!originalSrc.includes('!webp')) {
          originalSrc += '!webp'
        }
      } else if (!originalSrc.includes('!swebp')) {
        originalSrc += '!swebp'
      }
      //   console.log('originalSrc =', originalSrc);
    }
      el.setAttribute('src', originalSrc)
  }
}

export default vWebp
